import { createEvent, sample } from 'effector'

import { $clientRuntime, clientRuntimeSelected, resetPlayPageState } from '@/entities/game'

export const clientRuntimeToggled = createEvent()

sample({
    clock: clientRuntimeToggled,
    source: $clientRuntime,
    fn: (clientRuntime) => (clientRuntime === 'haxe' ? 'rust' : 'haxe'),
    target: clientRuntimeSelected,
})

sample({
    clock: clientRuntimeSelected,
    target: resetPlayPageState,
})
